export default __webpack_public_path__ + "static/media/133.e8435637.jpg";